import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { getUserUsageHistory } from "../thunk/tenantReport";

type UserUsageReportType = {
    event_type: string;
    sk: string;
    time: number;
    spend_time: number;
    pk: string;
    url: string;
    module?: string;
};
interface InitialState {
    tenantReportList: any;
    tenantUserReportList: any;
    userUsageReport: UserUsageReportType[];
    loading: boolean;
}

const initialState: InitialState = {
    tenantReportList: [],
    tenantUserReportList: [],
    userUsageReport: [],
    loading: false,
};
const tenantReportSlice = createSlice({
    name: "tenantReport",
    initialState,
    reducers: {
        setTenantReportList: (
            state: Draft<InitialState>,
            action: PayloadAction<any>
        ) => ({
            ...state,
            tenantReportList: action.payload,
        }),
        setTenantReportListWithUser: (
            state: Draft<InitialState>,
            action: PayloadAction<any>
        ) => ({
            ...state,
            tenantUserReportList: action.payload,
        }),
        setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            loading: action.payload,
        }),
        setUserUsageReport(state, action: PayloadAction<UserUsageReportType[]>) {
            return {
                ...state,
                userUsageReport: action.payload
            }
        }
    },
    extraReducers(builder) {
        builder.addCase(getUserUsageHistory.fulfilled, (state, action) => {
            return {
                ...state,
                userUsageReport: action.payload,
            }
        });
    },
});
export const { setTenantReportList, setTenantReportListWithUser, setLoader, setUserUsageReport } =
    tenantReportSlice.actions;
export default tenantReportSlice.reducer;
